import { render, staticRenderFns } from "./SetYourDomainModal.vue?vue&type=template&id=c458bfb4&scoped=true"
import script from "./SetYourDomainModal.vue?vue&type=script&lang=js"
export * from "./SetYourDomainModal.vue?vue&type=script&lang=js"
import style0 from "./SetYourDomainModal.vue?vue&type=style&index=0&id=c458bfb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c458bfb4",
  null
  
)

export default component.exports